import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';
import classNames from 'classnames';
import Abbr from '../../../shared/Abbr';

const xnLabel = {
    'Rules Races': 'Rules',
    'All-weather': 'AW',
};

const FilterBtn = ({ raceType, onClick, isSelected, hasAccess }) => (
    <button
        className={classNames(
            'ui-btn ui-btn_tiertiary',
            isSelected && 'ui-btn_major hp-raceRecords__colSelectedBtn'
            )}
        onClick={onClick}
        value={raceType}
        disabled={!hasAccess}
    >
        <span className="hp-raceRecords__filterButton">
            <span className="hp-raceRecords__label">
                {xnLabel[raceType] ? (
                    <Abbr title={raceType}>
                        {xnLabel[raceType]}
                    </Abbr>
                ) : raceType}
            </span>
            {isSelected &&
                <Svg
                    iconName="cross"
                    size="Small"
                    className="hp-raceRecords__cross tableShowIcon"
                />
            }
        </span>
    </button>
);

FilterBtn.propTypes = {
    raceType: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    isSelected: PropTypes.bool.isRequired,
    hasAccess: PropTypes.bool.isRequired,
};

export default FilterBtn;



// WEBPACK FOOTER //
// ./src/js/horse/form/raceRecords/FilterBtn.jsx